import React, { HTMLAttributes, useState } from 'react';
import { SizeUnitType } from '@meitu/saas-editor-core/es/utils/unit-kit';
import { useLocaleStore } from '@/i18n';
import { ListType } from '@/services/size-list/index.d';
import AddPopover from '../add-popover';
import './index.less';
import IconFont from '@meitu/xdesign-icon-font';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    item: ListType;
    hasCustomList?: boolean;
    className?: string;
    scrollClassName?: string;
    onSave?: (value: string, width: number, height: number, unit: SizeUnitType) => void;
    currentWidth: number;
    currentHeight: number;
}

const Title: React.FC<IProps> = (props) => {
    const { item, hasCustomList = true, ...resetProps } = props;
    const { $t } = useLocaleStore();
    const [showPopover, setShowPopover] = useState(false);

    return (
        <React.Fragment>
            <div className="adjust-size-panel-list__title" style={{ marginTop: item.is_custom ? 16 : 24 }}>
                <div className="adjust-size-panel-list__title-text">
                    {item.is_custom
                        ? $t((v) => v.panel.backgroundPanel.customSizeTitle)
                        : $t((v) => v.panel.backgroundPanel.recommendSizeTitle)}
                </div>
                {item.is_custom && hasCustomList ? (
                    <AddPopover
                        open={showPopover}
                        onClose={() => {
                            setShowPopover(false);
                        }}
                        {...resetProps}
                    >
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowPopover(true);
                            }}
                            className="adjust-size-panel-list__title-func"
                        >
                            <IconFont name="PlusCircleBold" fontSize={12} />
                            {$t((v) => v.panel.backgroundPanel.addSize)}
                        </div>
                    </AddPopover>
                ) : null}
            </div>
            {item.is_custom && !hasCustomList ? (
                <AddPopover
                    open={showPopover}
                    onClose={() => {
                        setShowPopover(false);
                    }}
                    {...resetProps}
                >
                    <div
                        className="adjust-size-panel-list__btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowPopover(true);
                        }}
                    >
                        <IconFont name="PlusCircleBold" fontSize={16} />
                        {$t((v) => v.panel.backgroundPanel.addSize)}
                    </div>
                </AddPopover>
            ) : null}
        </React.Fragment>
    );
};

export default Title;
